import { useQuery } from '@tanstack/react-query';
import { httpRequest } from '~/adapters/httpRequest.ts';

export const integrationKeys = {
  getWorkspaceFromSurveyId: (surveyId: string) => ['getWorkspaceFromSurveyId', surveyId],
};

export function useGetWorkspaceFromSurveyId({ surveyId, shouldRun }: { surveyId: string; shouldRun: boolean }) {
  return useQuery({
    queryKey: integrationKeys.getWorkspaceFromSurveyId(surveyId),
    queryFn: () =>
      httpRequest<{ payload: { workspace: string | null } }>(`/surveys/${surveyId}/integration-check`, {
        skipAuth: true,
      }).then((res) => res.payload.workspace),
    enabled: shouldRun,
  });
}
